import React from "react"
import "./styles.css"

const AppointmentCard = ({ appointment, selectedEvent }) => {
  const { title = "", image = "", price = "", quantity = 0 } = appointment

  return (
    <div className="ct-modal__confirm-card-small">
      <div
        className="ct-modal__confirm-card-small--image"
        style={{ backgroundImage: `url(${image})` }}
      ></div>
      <div className="ct-modal__confirm-card-small--content">
        <div className="ct-modal__confirm-card-small--heading--container">
          <span className="ct-modal__confirm-card-small--heading">{title}</span>
        </div>
        {/* <span className="ct-modal__confirm-card-small--subheading">Duration: {duration}</span> */}
        <div className="ct-modal__confirm-card-small--heading__sub">
          <span className="ct-modal__confirm-card-small--quantity">
            Spots remaining: {selectedEvent.resource.spotsRemaining}
          </span>
          <span className="ct-modal__confirm-card-small--price">
            Price: ${(price * quantity).toFixed(2)}
          </span>
        </div>
      </div>
      {/* <div className="ct-modal__confirm-card-small--quantity-container">
        <span className="ct-modal__confirm-card-small--quantity">Quantity: {quantity}</span>
      </div> */}
      {/* <div className="ct-modal__confirm-card-small--price-container"></div> */}
    </div>
  )
}

export default AppointmentCard
